<template>
  <div class="px-3 main-wrapper">
    <div>
      <div class="mt-3">
        <h3 class="mb-0 text-white text-center !text-[22px] !font-semibold">
          {{ $t("banking.bank_info") }}
        </h3>
      </div>
      <div
        class="error text-center py-2"
        v-if="error"
      >
        <span class="mx-auto">
          {{ error }}
        </span>
      </div>

      <div class="card-body bg-transparent">
        <form>
          <div class="mt-3">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="form-control-label"
                    for="name"
                    style="
                      color: #fff !important;
                      font-size: 1rem;
                      font-weight: 400 !important;
                    "
                  >{{ $t("banking.bank_username") }}</label>
                  <input
                    type="text"
                    class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0 text-lg"
                    v-model="account.name"
                    id="name"
                  />
                  <span class="text-danger">{{ errors.name }}</span>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="form-control-label"
                    for="number"
                    style="
                      color: #fff !important;
                      font-size: 1rem;
                      font-weight: 400 !important;
                    "
                  >{{ $t("banking.bank_number") }}</label>
                  <input
                    type="number"
                    class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0 text-lg"
                    v-model="account.account_number"
                    id="number"
                  />
                  <span class="text-danger">{{ errors.number }}</span>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label
                        class="form-control-label"
                        for="input-username"
                        style="
                          color: #fff !important;
                          font-size: 1rem;
                          font-weight: 400 !important;
                        "
                      >{{ $t("banking.bank_type") }}</label>
                      <!-- <AccountSelect
                        :data="account"
                        field="type"
                        :accounts="accounts" 
                      /> -->
                      <input
                        type="text"
                        readonly
                        @click="showPicker = true"
                        :value="accounts.find((acc) => acc.code === account.type)
                          ?.name
                          "
                        class="bg-transparent text-white border-0 cursor-pointer !border-b-[1px] w-full py-3 !border-white rounded-0"
                      />

                      <popup
                        v-model:show="showPicker"
                        destroy-on-close
                        round
                        position="bottom"
                      >
                        <picker
                          :model-value="account.type"
                          show-toolbar
                          :title="$t('banking.choose_bank')"
                          :cancel-button-text="$t('cancel')"
                          :confirm-button-text="$t('confirm')"
                          :columns="accountColumns"
                          @cancel="showPicker = false"
                          @confirm="onConfirm"
                        />
                      </popup>
                      <span class="text-danger">{{ errors.account }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-12 mt-2">
                <button
                  type="button"
                  class="bg-gradient-to-l text-white !text-[20px] from-[#924aff] to-[#4f3ffd] w-full !rounded-full py-3"
                  @click="updateBankInfo()"
                >
                  <div v-if="!isConfirm">
                    {{ $t("banking.submit") }}
                  </div>
                  <Loading
                    color="#ffffff"
                    v-if="isConfirm"
                    size="24"
                    class="px-4 py-0"
                  />
                </button>
              </div>
              <div class="col-12">
                <h3 style="
                    color: #ccc;
                    font-size: 1rem;
                    font-weight: 400 !important;
                  ">
                  ** {{ $t("banking.note") }} **
                </h3>
                <span style="color: #ccc; font-size: 0.9rem">
                  {{ $t("banking.note_content") }}
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions } from "vuex";
import { Picker, Popup } from "vant";
import AccountSelect from "./components/AccountSelect.vue";

export default {
  components: { AccountSelect, Loading, Picker, Popup },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      error: null,
      account: [],
      imageUploader: [],
      withdrawData: {},
      errors: {},
      showPicker: false,
      isConfirm: false,
      accounts: []
    };
  },
  computed: {
    accountColumns() {
      if (!this.accounts.length) return [];

      return this.accounts.map(bank => ({
        text: bank.name,
        value: bank.code,
      }));
    },
  },
  methods: {
    async getBanks() {
      const res = await axios.get('/banks');
      this.accounts = res.data.data;
    },
    onConfirm(value) {
      this.account.type = value.value;
      this.showPicker = false;
    },
    async fetchBankInfo() {
      try {
        const res = await axios.get("/user_bank", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.account = res.data.data ?? [];
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions(["fetchUser"]),
    async updateBankInfo() {
      try {
        this.error = null;
        if (!this.account.type) {
          this.error = this.$t('banking.account_type_error');
          return false;
        }
        if (!this.account.account_number) {
          this.error = this.$t('banking.account_number_error');
          return false;
        }
        if (!this.account.name) {
          this.error = this.$t('banking.account_name_error');
          return false;
        }

        this.isConfirm = true;

        await axios.put("/user_bank", this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.error = null;
        Toast.success("Success");
        this.isConfirm = false;
      } catch (error) {
        this.error = error.response.data;
        this.isConfirm = false;
      }
      return true;
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    await this.getBanks();
    await this.fetchBankInfo();
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    // if(authUser && !authUser.is_verified) {
    //   this.$router.push('/auth/verify');
    // }
  },
};
</script>
<style scoped>
.error {
  margin-bottom: 0;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 8px;
  padding: 0px 15px;
  margin-top: 2rem;
  background: transparent;
  /* font-weight: bold; */
}

.custom-btn {
  /* background: #FFFCFC !important; */
  background: #c7a241 !important;
  /* background: #000000 !important;  */
  /* border: 1px solid rgb(240 97 38 / 1) !important; */
  box-shadow: none !important;
  color: black !important;
  font-weight: 600;
  font-size: 1rem;
  width: 100% !important;
  /* border-radius: 25px; */
  height: 40px !important;
}

.custom-input,
.custom-input:active,
.custom-input:focus {
  /* background: transparent !important; */
  color: white !important;
  background-color: #000e22 !important;
  border: 1px solid #434f64 !important;
  border-radius: 0.5rem;
  text-align: center;
  /* height: 50px; */
  font-size: 1.3rem;
  font-weight: 300;
  box-shadow: none;
}

.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  background: #e9ecef;
  justify-content: center;
}

.custom-file {
  height: auto;
}
</style>
